import { render, staticRenderFns } from "./List.vue?vue&type=template&id=20ad9fa2&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "../main.css?vue&type=style&index=0&id=20ad9fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad9fa2",
  null
  
)

export default component.exports